import { Link } from "react-router-dom";
import { dramas } from "@/mocks/dramas";
import { newsList } from "@/mocks/news";
import HeroCarousel from "./components/HeroCarousel";
import QuickEntries from "./components/QuickEntries";
import SectionHeader from "@/components/feature/SectionHeader";
import DramaCard from "@/components/feature/DramaCard";
import NewsCard from "@/components/feature/NewsCard";
import { usePageMeta } from "@/hooks/usePageMeta";

const wrap = "mx-auto w-full max-w-[1280px] px-4 md:px-6";

export default function Home() {
  usePageMeta(
    "泰剧腐剧双男主-热门泰国双男主剧情推荐和影视资讯",
    "泰剧腐剧双男主提供最新的泰国双男主腐剧剧情介绍、影视资讯和剧集推荐，涵盖多部受欢迎的双男主泰剧内容，助您轻松了解并选择心仪作品。",
  );

  const latest = [...dramas].sort((a, b) => b.updateDate.localeCompare(a.updateDate)).slice(0, 8);
  const hot = [...dramas].sort((a, b) => b.views - a.views).slice(0, 8);
  const topNews = newsList.slice(0, 3);
  const totalViews = dramas.reduce((sum, d) => sum + d.views, 0);

  return (
    <div>
      <HeroCarousel />

      <section className={`${wrap} relative z-10 -mt-10`}>
        <QuickEntries />
      </section>

      <section className={`${wrap} mt-14`}>
        <SectionHeader
          title="最新剧集"
          subtitle="按更新时间倒序，追更不错过任何一部新剧"
          icon="ri-time-line"
          moreTo="/category/最新更新"
        />
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {latest.map((drama, i) => (
            <DramaCard key={drama.id} drama={drama} index={i} />
          ))}
        </div>
      </section>

      <section className="mt-16 bg-background-100 py-14">
        <div className={wrap}>
          <SectionHeader
            title="热门剧集推荐"
            subtitle="综合热度与人气，当下最值得一看的双男主剧单"
            icon="ri-fire-line"
            moreTo="/category/热门推荐"
          />
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
            {hot.map((drama, i) => (
              <DramaCard key={drama.id} drama={drama} index={i} />
            ))}
          </div>
        </div>
      </section>

      <section className={`${wrap} mt-16`}>
        <SectionHeader
          title="影视资讯"
          subtitle="最新泰剧动态、行业观察与幕后报道"
          icon="ri-newspaper-line"
          moreTo="/news"
        />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {topNews.map((item, i) => (
            <NewsCard key={item.id} item={item} index={i} />
          ))}
        </div>
      </section>

      <section className={`${wrap} mt-16`}>
        <div className="overflow-hidden rounded-lg border border-background-200 bg-gradient-to-r from-primary-50 via-background-50 to-accent-50 p-6 md:p-10">
          <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
            <div className="max-w-2xl">
              <h2 className="font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">
                关于泰剧腐剧双男主
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
                我们是一个专注泰国双男主题材影视的内容聚合平台。从热门剧集到冷门口碑作，从剧情简介到角色解析，我们希望用清晰的内容分类与真实的剧集资料，帮助每一位观众更轻松地了解作品、选择想看的剧。
              </p>
              <Link
                to="/about"
                className="mt-5 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
              >
                了解更多 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-3 gap-6 lg:gap-10">
              <div>
                <p className="font-heading text-2xl font-black text-primary-600 md:text-3xl">{dramas.length}</p>
                <p className="mt-1 text-xs text-foreground-500 md:text-sm">收录剧集</p>
              </div>
              <div>
                <p className="font-heading text-2xl font-black text-primary-600 md:text-3xl">
                  {(totalViews / 10000).toFixed(0)}万
                </p>
                <p className="mt-1 text-xs text-foreground-500 md:text-sm">累计关注</p>
              </div>
              <div>
                <p className="font-heading text-2xl font-black text-primary-600 md:text-3xl">12+</p>
                <p className="mt-1 text-xs text-foreground-500 md:text-sm">题材标签</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}